const PlusOutlined = () => {
    return <span className='plusOutlined-icon'/>;
};

export default PlusOutlined;
